import { Grid, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "20px 0 0",

  "&:hover": {
    cursor: "pointer",
  },
});

export const TransactionInfo = styled(Typography)({
  margin: 0,
});

export const RemoveButton = styled(IconButton)({
  padding: "8px 10px",
});
